var QueryKey;
(function (QueryKey) {
  QueryKey["postComment"] = "postComment";
  QueryKey["putComment"] = "putComment";
  QueryKey["deleteComment"] = "deleteComment";
  QueryKey["putLikeComment"] = "putLikeComment";
  QueryKey["getReplies"] = "getCommnetReplies";
  QueryKey["getCommentReplies"] = "getCommentReplies";
  QueryKey["getComments"] = "getComments";
  QueryKey["unsubscribeNotification"] = "unsubscribeNotification";
})(QueryKey || (QueryKey = {}));

export { QueryKey };
